import { HttpLink } from 'apollo-link-http'
import ApolloClient from 'apollo-client'
import { ApolloLink, concat } from 'apollo-link'
import { InMemoryCache } from 'apollo-cache-inmemory'
const GRAPHQL_URL = process.env.GRAPHQL_URL

const httpLink = new HttpLink({ uri: GRAPHQL_URL || 'http://localhost:3000/graphql' })
const authMiddleware = new ApolloLink((operation, forward) => {
  const token = localStorage.getItem('heimdall-session-token')
  operation.setContext({
    headers: {
      authorization: token ? `Bearer ${token}` : null
    }
  })
  return forward(operation)
})

const client = new ApolloClient({
  link: concat(authMiddleware, httpLink),
  cache: new InMemoryCache()
})

export default client



// WEBPACK FOOTER //
// ./src/api/apollo.js